export const shouldDisplayAnnualProposalPremium = (proposalData) =>
  proposalData?.premiumSummary?.isAnnual === true && proposalData?.capabilities?.showAnnualContractValues === true;

export const getProposalPremiumDisplay = ({ proposalData, valueCoverage, valueService }) => {
  if (shouldDisplayAnnualProposalPremium(proposalData)) return proposalData.premiumSummary;

  const persistedIof = Number(proposalData?.iof || 0);

  return {
    netCoverage: Number(proposalData?.isHinova ? proposalData?.valueFinal : valueCoverage) - persistedIof,
    iof: persistedIof,
    service: valueService,
    total: Number(proposalData?.valueFinal || 0),
  };
};
